
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developers/overview",
      function () {
        return require("private-next-pages/developers/overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developers/overview"])
      });
    }
  